/** @format */

import React from 'react';

export const MegaMenuCartons = ({onMouseLeave, onMouseOver, isMobile, display = 'none'}) => {
    const cartonProductTypeLinks = {
        base: '/cartons/carton-types',
        cosmetic: '/cartons/carton-types/custom-cosmetic-cartons-skincare-packaging',
        cbd: '/cartons/carton-types/custom-cbd-cartons',
        supplement: '/cartons/carton-types/custom-vitamin-supplement-cartons',
        vape: '/cartons/carton-types/custom-vape-cartons',
        candle: '/cartons/carton-types/custom-candle-cartons',
        soap: '/cartons/carton-types/custom-soap-cartons',
        coffee: '/cartons/carton-types/custom-coffee-cartons',
        tea: '/cartons/carton-types/custom-tea-bag-cartons'
    };

    const cartonMaterialAndLaminatesLinks = {
        materials_base: '/cartons/carton-materials',
        white_paper: '/cartons/carton-materials/white-paper-cartons',
        bright_white_paper: '/cartons/carton-materials/bright-white-paper-cartons',
        metallic_paper: '/cartons/carton-materials/metallic-paper-cartons',
        rainbow_holographic: '/cartons/carton-materials/holographic-cartons',
        white_vellum: '/cartons/carton-materials/white-vellum-paper-cartons',
        black_vellum: '/cartons/carton-materials/black-vellum-cartons',
        laminates_base: '/cartons/carton-laminates',
        gloss: '/cartons/carton-laminates/gloss-laminate',
        soft_touch_matte: '/cartons/carton-laminates/soft-touch-matte-laminate',
        matte: '/cartons/carton-laminates/matte-laminate',
        linen: '/cartons/carton-laminates/linen-laminate',
        leather: '/cartons/carton-laminates/leather-laminate'
    };

    const orderCartons = '/orders/custom-cartons';
    return (
        <div
            className="header-23cr_megamenus-toggler megamenus-toggler--cartons"
            onMouseLeave={!isMobile ? onMouseLeave : null}
            onMouseOver={!isMobile ? onMouseOver : null}
            style={{display}}>
            <nav
                aria-labelledby="sub-nav"
                className="header-23cr_megamenu-container megamenu-container-cartons">
                <div className="header-23cr_megamenu">
                    <div className="megamenu-23cr_links">
                        {/*  Image Lnk*/}
                        <div className="links-23cr_link link-image">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={cartonProductTypeLinks['base']}>Custom Cartons</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div
                                className="link-image-23cr_image"
                                style={{
                                    backgroundImage: `linear-gradient(0deg, rgba(20, 20, 20, 0.55), rgba(20, 20, 20, 0.55)),  url('/images/header_footer/products_cartons.webp')`
                                }}>
                                <a href={orderCartons}>
                                    <h6>Get An Instant Quote</h6>
                                </a>
                            </div>
                        </div>

                        {/*  Product Types */}
                        <div className="links-23cr_link">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={cartonProductTypeLinks['base']}>Product Types</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                {/* first column*/}
                                <ul className="links-list-23cr_column column-first">
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['cosmetic']}`}
                                            className="d-block">
                                            Cosmetic Cartons
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['cbd']}`}
                                            className="d-block">
                                            CBD Cartons
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['supplement']}`}
                                            className="d-block">
                                            Supplement Cartons
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['vape']}`}
                                            className="d-block">
                                            Vape Cartons
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['candle']}`}
                                            className="d-block">
                                            Candle Cartons
                                        </a>
                                    </li>
                                </ul>
                                <ul className="links-list-23cr_column column-second">
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['soap']}`}
                                            className="d-block">
                                            Soap Cartons
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['coffee']}`}
                                            className="d-block">
                                            Coffee Cartons
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${cartonProductTypeLinks['tea']}`}
                                            className="d-block">
                                            Tea Cartons
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/*  Materials  */}
                        <div className="links-23cr_link links-23cr_link-cartons-materials-and-laminates">
                            <div className="link-23cr_title">
                                <h3>
                                    <a
                                        className="column_heading-link"
                                        href={cartonMaterialAndLaminatesLinks['materials_base']}>
                                        Materials
                                    </a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z"></path>
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['white_paper']}
                                            className="d-block">
                                            White Paper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                cartonMaterialAndLaminatesLinks[
                                                    'bright_white_paper'
                                                ]
                                            }
                                            className="d-block">
                                            Bright White Paper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['metallic_paper']}
                                            className="d-block">
                                            Metallic Paper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                cartonMaterialAndLaminatesLinks[
                                                    'rainbow_holographic'
                                                ]
                                            }
                                            className="d-block">
                                            Rainbow Holographic
                                        </a>
                                    </li>
                                </ul>
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['black_vellum']}
                                            className="d-block">
                                            Black Vellum
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['white_vellum']}
                                            className="d-block">
                                            White Vellum
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* Laminates*/}
                        <div className="links-23cr_link links-23cr_link-cartons-materials-and-laminates">
                            <div className="link-23cr_title">
                                <h3>
                                    <a
                                        className="column_heading-link"
                                        href={cartonMaterialAndLaminatesLinks['laminates_base']}>
                                        Laminates
                                    </a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z"></path>
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['gloss']}
                                            className="d-block">
                                            Gloss
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={
                                                cartonMaterialAndLaminatesLinks['soft_touch_matte']
                                            }
                                            className="d-block">
                                            Soft Touch Matte
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['matte']}
                                            className="d-block">
                                            Matte
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['linen']}
                                            className="d-block">
                                            Linen
                                        </a>
                                    </li>
                                </ul>
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <a
                                            href={cartonMaterialAndLaminatesLinks['leather']}
                                            className="d-block">
                                            Leather
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};
